import { defineProperty as _defineProperty } from './_virtual/_rollupPluginBabelHelpers.js';
import { Decision } from './Decision.js';

class DecisionTree {
  constructor() {
    _defineProperty(this, "branches", []);
    _defineProperty(this, "defaultAction", null);
  }
  when(condition, action) {
    this.branches.push(new Decision(condition, action));
    return this;
  }
  default(action) {
    this.defaultAction = action;
    return this;
  }
  evaluate(data, depth = 0) {
    for (const branch of this.branches) {
      const result = branch.evaluate(data, depth);
      if (result !== null) {
        return result;
      }
    }
    if (this.defaultAction) {
      return typeof this.defaultAction === 'function' ? this.defaultAction(data, depth) : this.defaultAction;
    }
    return null;
  }
}

export { DecisionTree };
//# sourceMappingURL=DecisionTree.js.map
